import React, { PureComponent } from 'react';
import { List } from 'semantic-ui-react';

import './styles.scss';

interface OwnProps {
    description: string;
    value: string | number | undefined | React.ReactElement;
}

export type Props = OwnProps;

export default class ListItem extends PureComponent<Props> {
    render(): React.ReactElement {
        const {
            description,
            value
        } = this.props;

        return (
            <List.Item className="list-item">
                <List.Content>
                    <span className="list-item-description">{description}</span>
                    <span className="list-item-value">{value}</span>
                </List.Content>
            </List.Item>
        );
    }
}
